import React, {Component} from 'react';
import SearchDropdown from '../widgets/SearchDropdown';
import fetchJson from '../fetchJson';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import uiActions from '../chrome/ui.actions';
import {push} from 'connected-react-router';
import './ProviderSearchDropdown.css';
import Avatar from '../widgets/Avatar';
import actions from './search.actions';

class ProviderSearchDropdown extends Component {
	constructor(props) {
		super(props);

		this.performSearch = async (query, limit = 5) => {
			try {
				return await fetchJson(`/api/search/${encodeURIComponent(query)}?limit=${limit}`);
			} catch (e) {
				this.props.onError();
			}
		};

		this.renderItem = ({
			profile: {uniqueName, backgroundImage, avatarImage, backgroundPosition = 33} = {},
			isHighlighted,
			onClick,
			onMouseOver,
			onMouseOut,
			user: {uuid, firstname, lastname, location}
		}) => {
			return (
				<li
					className={`ProviderSearchDropdown-item ${isHighlighted ? 'highlighted' : ''}`}
					onMouseDown={() => onClick(uuid)}
					onMouseOver={() => onMouseOver(uuid)}
					onMouseOut={() => onMouseOut(uuid)}>
					<Avatar size={32} backgroundImage={avatarImage} />
					<div className="ProviderSearchDropdown-item-name">
						{firstname} {lastname}
					</div>
					<div className="ProviderSearchDropdown-item-extra">{location && location.suburb}</div>
				</li>
			);
		};

		this.keyFunc = item => item && item.profile && item.profile.uniqueName;
	}

	render() {
		return (
			<SearchDropdown
				className="ProviderSearchDropdown"
				wrapperClassName="ProviderSearchDropdown"
				keyFunc={this.keyFunc}
				onSearch={this.performSearch}
				onSelect={this.props.onSelect}
				itemRenderer={this.renderItem}
				placeholder="Type to search for a provider"
				extra={<span className="icon icon-search" />}
				onShowMore={this.props.onShowMore}
				scrollInOnShow={this.props.screenSize === 'mobile'}
				scrollIntoViewElement={this.props.scrollIntoViewElement}
			/>
		);
	}
}

const ConnectedProviderSearchDropdown = connect(
	({ui}) => ({
		screenSize: ui && ui.screenSize
	}),
	dispatch => ({
		onShowMore: value => {
			dispatch(actions.searchFor('provider'));
			dispatch(push('/search/' + encodeURIComponent(value)));
		},
		onError: () => dispatch(uiActions.uiModal('error'))
	})
)(ProviderSearchDropdown);

export default ConnectedProviderSearchDropdown;



// WEBPACK FOOTER //
// ./src/search/ProviderSearchDropdown.js